<template>
    <div class="takequiz">
    <h2> {{lang.question}}</h2>
    <button v-on:click="selectType(2)">{{lang.two}}</button> <br/>
    <button v-on:click="selectType(3)">{{lang.three}} </button>
    <!-- {{twoPoint}} -->
    </div>
</template>
<script>
export default {
  name: 'QuestionType',
  data () {
    return {
     }
  },
  props: {
    msg: String,
    lang: Object
  },
  methods: {
      selectType: function(point) {
        // let currq = this.twoPoint.pop()
        // this.twoqueue = this.twoPoint;
        this.$emit('selected-type', point)
        // console.log(this.twoPoint.pop())
       }
  }
}
</script>

<style>

</style>
